module.exports = __webpack_public_path__ + "img/shopee.88979cc0.png";